interface BlockFormValueEntry {
  path: string;
  value: unknown;
}

function collectLeafEntries(
  value: unknown,
  path: string,
  instanceIndex?: number,
  instanceSelected = false,
): BlockFormValueEntry[] {
  if (Array.isArray(value)) {
    if (instanceIndex !== undefined && !instanceSelected) {
      return collectLeafEntries(
        value[instanceIndex],
        `${path}.${instanceIndex}`,
        instanceIndex,
        true,
      );
    }
    return value.flatMap((item, index) =>
      collectLeafEntries(item, `${path}.${index}`, instanceIndex, instanceSelected),
    );
  }
  if (value && typeof value === 'object') {
    return Object.entries(value).flatMap(([name, nestedValue]) =>
      collectLeafEntries(
        nestedValue,
        path ? `${path}.${name}` : name,
        instanceIndex,
        instanceSelected,
      ),
    );
  }
  return path ? [{ path, value }] : [];
}

export function getBlockFormValueEntries(
  namespace: string,
  namespaceValue: unknown,
  formFieldNames: string[],
  instanceIndex?: number,
): BlockFormValueEntry[] {
  const configuredNames = new Set(formFieldNames.map((name) => name.split('.').pop()!));
  const entries = collectLeafEntries(namespaceValue, namespace, instanceIndex);
  if (!configuredNames.size) return entries;

  return entries.filter(({ path }) => configuredNames.has(path.split('.').pop()!));
}
